
<div class="content1" *ngIf="stage === 1">
  <div class="step-row">
    <div class="step on"></div>
    <div class="step"></div>
    <!-- <div class="step"></div> -->
  </div>

  <h1 class="page-title">How will you use Rondeivu?</h1>
  <p class="page-sub">Choose your role to get started. Already have an account? <a routerLink="/auth/login">Sign in</a></p>

  <div class="cards" id="cards">

    <!-- Issuer card -->
    <div class="role-card" [class.selected]="userProfile === 'issuer'" id="card-issuer" (click)="userProfile = 'issuer'">
      <div class="radio-dot"></div>
      <div class="card-icon">
        <!-- Building / issuer icon -->
        <img src="assets/images/default-issuer.png" alt="Issuer Icon" />
      </div>
      <div class="card-label">Issuer</div>
      <div class="card-desc">Bring your deal to market and fundraise for private placements, co-investments, and fund opportunities with institutional LPs</div>
      <div class="card-tags">
        <span class="tag">Operating Companies</span>
        <span class="tag">General Partners</span>
        <span class="tag">Financial Institutions</span>
      </div>
    </div>

    <!-- Investor card – pre-selected for demo -->
    <div class="role-card" [class.selected]="userProfile === 'investor'" id="card-investor" (click)="userProfile = 'investor'">
      <div class="radio-dot"></div>
      <div class="card-icon">
        <!-- Chart / investor icon -->
        <img src="assets/images/default-investor.png" alt="Investor Icon" />
      </div>
      <div class="card-label">Investor</div>
      <div class="card-desc">Access, evaluate and execute on a curated pipeline of institutional-quality private market opportunities</div>
      <div class="card-tags">
        <span class="tag">Family Offices</span>
        <span class="tag">Pensions/Funds</span>
        <span class="tag">Asset Managers</span>
      </div>
    </div>

  </div><!-- /cards -->

  <div class="cta-area">
    <button mat-raised-button color="primary" (click)="goToReg()"
      [disabled]="!userProfile">
      <div style="display: flex; align-items: center;">
      <span>Continue as an</span> &nbsp;
      <span style="text-transform: capitalize;">{{userProfile}}</span>&nbsp;
      <mat-icon>arrow_forward</mat-icon>

      </div>
    </button>
    <span class="signin-note">Step 1 of 2</span>
  </div>

  
  <div class="mat-divider"></div>
  <div class="page-foot">
    <span>Southport, CT · Toronto, ON</span>
    <span>&copy; {{currentYear}} Rondeivu, Inc.</span>
    <br>
    <span class="regulatory-main-foorter">Rondeivu operates through its affiliates: Rondeivu Securities, LLC (US broker-dealer), Rondeivu Advisory, LLC (Connecticut state investment adviser), and Rondeivu (Canada) Inc. (Canadian EMD/PM). See our full regulatory disclosures on our homepage.</span>
  </div>


</div>

<div class="content1" *ngIf="stage === 2">
  <div class="step-row">
    <div class="step"></div>
    <div class="step on"></div>
  </div>


  <div *ngIf="!tokenDecoded">
    <h1 class="page-title">Register as an <span class="user-profile">{{userProfile}}</span></h1>
    <p class="page-sub">Already have an account? <a routerLink="/auth/login">Sign in</a></p>
  </div>

  <div *ngIf="tokenDecoded">
    <h1 class="page-title">Please Register to gain access.</h1>

    <p class="page-sub" *ngIf="!tokenDecoded.invitedDealProjectName">
      You have been invited to join the deal team at 
      <b>{{ tokenDecoded.invitedBusinessName }}</b> by <b>{{ tokenDecoded.invitedPerson }}</b>.
    </p>

    <p class="page-sub" *ngIf="tokenDecoded.invitedDealProjectName">
      You have been invited to join the deal team of <b>{{ tokenDecoded.invitedDealProjectName }}</b> at 
      <b>{{ tokenDecoded.invitedBusinessName }}</b> by <b>{{ tokenDecoded.invitedPerson }}</b>.
    </p>

  </div>


  <!--  there is a profile-->
  <div class="row justify-content-center auth-container pt-2">
    <form [formGroup]="userForm" (ngSubmit)="registerUser()">
      <!--  registration form start-->
      <div class="card-body">
        <!--          First Name-->
        <div class="form-flex-row">
          <mat-form-field class="form-field" appearance="fill">
            <mat-label>First Name</mat-label>
            <input type="text" matInput formControlName="firstName" />
            <mat-error *ngIf="userForm.get('firstName')?.getError('required')">First Name is required</mat-error>
          </mat-form-field>
          <mat-form-field class="form-field" appearance="fill">
            <mat-label>Last Name</mat-label>
            <input type="text" matInput formControlName="lastName" />
            <mat-error *ngIf="userForm.get('lastName')?.getError('required')">Last Name is required</mat-error>
          </mat-form-field>
        </div>
        <!--          Email-->
        <div class="form-flex-row">
          <mat-form-field class="form-field" appearance="fill">
            <mat-label>Email</mat-label>
            <input type="email" autocomplete="off" matInput formControlName="email"/>
            <mat-icon matSuffix class="green" *ngIf="isMinimalInviteRegistration">check</mat-icon>
            <mat-error *ngIf="userForm.get('email')?.getError('required')">Email is required</mat-error>
            <mat-error *ngIf="userForm.get('email')?.getError('email')">Invalid email format</mat-error>
          </mat-form-field>
        </div>
        <!--          Password-->
        <div class="form-flex-row">
          <mat-form-field class="form-field"  appearance="fill">
            <mat-label>Password</mat-label>
            <input matInput autocomplete="off" formControlName="password" [type]="showPassword ? 'text' : 'password'"/>
            <mat-icon matSuffix class="pointer" 
              [title]="showPassword ? 'Hide Password' : 'Show Password'"
              (click)="showPassword = !showPassword">
              {{showPassword ? 'visibility_off' : 'visibility'}}
            </mat-icon>
            <mat-error *ngIf="userForm.get('password')?.getError('required')">Password is required</mat-error>
            <mat-error *ngIf="userForm.get('password')?.getError('pattern')">
              Password must contain lowercase, uppercase, numbers, special characters, and be at least 8 characters
            </mat-error>
          </mat-form-field>
        </div>

        <div *ngIf="!isMinimalInviteRegistration">
          <div class="form-flex-row">
            <mat-form-field class="form-field" appearance="fill">
              <mat-label>Company Name</mat-label>
              <input id="cn" matInput formControlName="companyName"/>
              <mat-error *ngIf="userForm.get('companyName')?.getError('required')">Company Name is required</mat-error>
            </mat-form-field>
              <mat-form-field class="form-field" appearance="fill">
                <mat-label>Job Title</mat-label>
                <input id="jt" matInput formControlName="jobTitle"/>
                <mat-error *ngIf="userForm.get('jobTitle')?.getError('required')">Job Title is required</mat-error>
              </mat-form-field>
          </div>
          <!--Country of Domicile-->
          <div class="form-flex-row">
            <mat-form-field class="form-field" appearance="fill">
              <mat-label>Country of Domicile</mat-label>
              <mat-select id="cod" formControlName="countryId">
                <mat-option *ngFor="let opt of lookupService.lookups.countries" [value]="opt.key">
                  {{ opt.value }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="userForm.get('countryId')?.getError('required')">Country of Domicile is required</mat-error>
            </mat-form-field>

            <!--          Type of investor-->
            <mat-form-field class="form-field"  appearance="fill" *ngIf="userProfile === 'investor'">
              <mat-label>Type of Investor</mat-label>
              <mat-select id="toi" formControlName="subType">
                <mat-option *ngFor="let i of lookupService.lookups.investorTypes" [value]="i.key">
                  {{ i.value }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="userForm.get('subType')?.getError('required')">Type of Investor is required</mat-error>
            </mat-form-field>

            <!--          Type of issuer-->
            <mat-form-field class="form-field" appearance="fill" *ngIf="userProfile === 'issuer'">
              <mat-label>Type of Issuer</mat-label>
              <mat-select id="ti" formControlName="subType">
                <mat-option *ngFor="let i of lookupService.lookups.issuerTypes" [value]="i.key">
                  {{ i.value }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="userForm.get('subType')?.getError('required')">Type of Issuer is required</mat-error>
            </mat-form-field>
          </div>
        </div>
        <!-- <div class="row justify-content-center">
          <div class="text-center">
            <button mat-raised-button type="submit" color="primary" [disabled]="apiCallInProgress">Register</button>
          </div>
        </div> -->

        <div class="cta-area">
          <button mat-raised-button color="primary" type="submit">
            Create Account
          </button>
          <span class="signin-note">
            Almost there!
          </span>
        </div>

      </div>
    </form>
  </div>

  
  <div class="mat-divider"></div>
  <div class="page-foot">
    <span>Southport, CT · Toronto, ON</span>
    <span>&copy; {{currentYear}} Rondeivu, Inc.</span>
    <br>
    <span class="regulatory-main-foorter">Rondeivu operates through its affiliates: Rondeivu Securities, LLC (US broker-dealer), Rondeivu Advisory, LLC (Connecticut state investment adviser), and Rondeivu (Canada) Inc. (Canadian EMD/PM). See our full regulatory disclosures on our homepage.</span>
  </div>



</div>
